import OwnersSimpleView from './OwnersSimpleView'

export default OwnersSimpleView
